const buttons = ['button', 'button:hover', 'button:focus', 'button:active'];
const input = ['input', 'input:hover', 'input:focus', 'input:active'];
const pinInput = ['pinInput', 'pinInput:hover', 'pinInput:focus', 'pinInput:active'];
const checkbox = ['checkbox', 'checkbox:hover', 'checkbox:checked', 'checkbox:disabled'];
const label = ['label'];
const hint = ['hint'];
const link = ['link', 'link:hover', 'link:focus'];
const linkButton = ['linkButton', 'linkButton:hover', 'linkButton:focus', 'linkButton:active'];
const pageHeader = ['pageHeader'];
const pageHeaderTitle = ['pageHeaderTitle'];
const pageHeaderSubtitle = ['pageHeaderSubtitle'];

const whitelist = [
  ...buttons,
  ...input,
  ...pinInput,
  ...checkbox,
  ...label,
  ...hint,
  ...link,
  ...linkButton,
  ...pageHeader,
  ...pageHeaderTitle,
  ...pageHeaderSubtitle,
];

export default whitelist;
